var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeYes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_9185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6836 4C7.68359 4 3.41359 7.11 1.68359 11.5C3.41359 15.89 7.68359 19 12.6836 19C17.6836 19 21.9536 15.89 23.6836 11.5C21.9536 7.11 17.6836 4 12.6836 4ZM12.6836 16.5C9.92359 16.5 7.68359 14.26 7.68359 11.5C7.68359 8.74 9.92359 6.5 12.6836 6.5C15.4436 6.5 17.6836 8.74 17.6836 11.5C17.6836 14.26 15.4436 16.5 12.6836 16.5ZM12.6836 8.5C11.0236 8.5 9.68359 9.84 9.68359 11.5C9.68359 13.16 11.0236 14.5 12.6836 14.5C14.3436 14.5 15.6836 13.16 15.6836 11.5C15.6836 9.84 14.3436 8.5 12.6836 8.5Z",
    fill: "#54565B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_9185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.683594)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeYes);
export default __webpack_public_path__ + "static/media/eye-yes.6a75fc79b3168b936fdfbd5a44e9d669.svg";
export { ForwardRef as ReactComponent };